<template>
  <ol class="docs-steps">
    <li>Fill in your details in the generator and click <b>Copy Signature</b>.</li>
    <li>In Mail open <b>Mail → Settings</b> (<kbd class="docs-kbd">⌘ ,</kbd>) and select the <b>Signatures</b> tab.</li>
    <li>
      Select your account in the left column and click the <b>+</b> button to add a new signature.
      Give it a name (e.g. “No. J Signature”).
    </li>
    <li>
      Untick <b>Always match my default message font</b>, then click in the preview area on the right,
      delete the default text (your name and email) and paste (<kbd class="docs-kbd">⌘ V</kbd>).
    </li>
    <li>Choose the new signature from the <b>Choose Signature</b> menu at the bottom and close the Settings window.</li>
    <li>Create a <b>New Message</b> to check the result.</li>
  </ol>

  <p class="docs-note">
    If the layout looks off after pasting, follow the advanced guide below to install the HTML file directly.
  </p>

  <a
    href="https://matt.coneybeare.me/how-to-make-an-html-signature-in-apple-mail-for-macos-sonoma-14/"
    target="_blank"
    rel="noopener noreferrer nofollow"
    class="docs-link"
  >
    How to add an HTML signature in Apple Mail (macOS Sonoma) ↗
  </a>
</template>
